// Webpack
// import "bootstrap";
import "jquery-match-height";
import MicroModal from "micromodal";
// import Swiper from "swiper";
// import objectFitImages from "object-fit-images";
import AOS from "aos";
import { LuminousGallery } from "luminous-lightbox";

const bodyScrollLock = require("body-scroll-lock");
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

MicroModal.init();
AOS.init();

// Mobile navigation
const setHeaderPadding = () => {
  let headerHeight = document.getElementById("masthead").offsetHeight;
  document.body.style.paddingTop = `${headerHeight}px`;
};

window.addEventListener("DOMContentLoaded", () => {
  setHeaderPadding();
  window.addEventListener("resize", setHeaderPadding);

  // Mobile navigation
  const mobileNavigation = document.getElementById("mobile-navigation");
  const headerToggleBtn = document.getElementsByClassName(
    "header-toggle-btn"
  )[0];

  const closeNavigation = () => {
    MicroModal.close("mobile-navigation");
    enableBodyScroll(mobileNavigation);
  };

  const openNavigation = () => {
    MicroModal.show("mobile-navigation", {
      disableScroll: false,
      disableFocus: true,
      awaitCloseAnimation: true,
    });
    disableBodyScroll(mobileNavigation);
    // ヘッダーの高さを取得
    let headerHeight = document.getElementById("masthead").offsetHeight;
    mobileNavigation.style.top = `${headerHeight}px`;
  };

  headerToggleBtn.addEventListener("click", () => {
    headerToggleBtn.classList.toggle("is-active");
    let headerToggleBtnIcon = document.querySelector(
      ".header-toggle-btn__icon"
    );

    headerToggleBtnIcon.classList.toggle("ri-menu-line");
    headerToggleBtnIcon.classList.toggle("ri-close-line");

    if (mobileNavigation.classList.contains("is-open")) {
      closeNavigation();
    } else {
      openNavigation();
    }
  });
});

// Swiper.js
window.addEventListener("DOMContentLoaded", () => {
  const staffSliderTop = new Swiper(".staff-slider-top", {
    loop: true,
    speed: 8000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    slidesPerView: 7,
    spaceBetween: 8,
    preventInteractionOnTransition: true,
    loopedSlides: 8,
    centeredSlides: true,
    breakpoints: {
      992: {
        slidesPerView: 3.5,
        spaceBetween: 4,
      },
    },
  });

  const staffSliderBottom = new Swiper(".staff-slider-bottom", {
    loop: true,
    speed: 8000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    slidesPerView: 7,
    spaceBetween: 8,
    preventInteractionOnTransition: true,
    loopedSlides: 8,
    centeredSlides: true,
    breakpoints: {
      992: {
        slidesPerView: 3.5,
        spaceBetween: 4,
      },
    },
  });

  const reviewSlider = new Swiper(".review-slider", {
    slidesPerView: 3.1,
    spaceBetween: 8,
    centeredSlides: false,
    navigation: {
      nextEl: ".review-button-next",
      prevEl: ".review-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 1.2,
        spaceBetween: 8,
        centeredSlides: true,
      },
    },
  });

  const accessSlider = new Swiper(".block-access-slider", {
    slidesPerView: 1,
    spaceBetween: 8,
    centeredSlides: true,
    navigation: {
      nextEl: ".access-button-next",
      prevEl: ".access-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
  });

  const historySlider = new Swiper(".history-slider", {
    slidesPerView: 7,

    freeMode: true,
    watchSlidesProgress: true,
    scrollbar: {
      el: ".swiper-scrollbar",
      hide: false,
    },
    breakpoints: {
      992: {
        slidesPerView: 3.5,
      },
    },
  });

  if ("slides" in historySlider) {
    const totalHistorySlide = jQuery(
      ".history-slider  > .swiper-wrapper > .swiper-slide"
    ).length;
    historySlider.slideTo(totalHistorySlide, 300, false);
  }

  const workplaceScenerySliderTop = new Swiper(
    ".workplace-scenery-slider-top",
    {
      loop: true,
      speed: 12000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      autoHeight: true,
      slidesPerView: 4,
      spaceBetween: 8,

      preventInteractionOnTransition: true,
      loopedSlides: 8,
      centeredSlides: true,
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 4,
        },
      },
    }
  );

  const workplaceScenerySliderBottom = new Swiper(
    ".workplace-scenery-slider-bottom",
    {
      loop: true,
      speed: 12000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true,
      },
      autoHeight: true,
      slidesPerView: 4,
      spaceBetween: 8,

      preventInteractionOnTransition: true,
      loopedSlides: 8,
      centeredSlides: true,
      breakpoints: {
        992: {
          slidesPerView: 2,
          spaceBetween: 4,
        },
      },
    }
  );

  const blockPriceComparisonSlider = new Swiper(
    ".block-price-comparison__case",
    {
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 4,
      centeredSlides: true,
      pagination: {
        el: ".swiper-pagination",
      },
      navigation: {
        nextEl: ".block-price-comparison-button-next",
        prevEl: ".block-price-comparison-button-prev",
      },
    }
  );
});

// c-title-03 adjustImgSize
// const adjustImgSize = () => {
//   let icons = document.querySelectorAll(".c-title-03__icon");
//   icons.forEach((icon) => {
//     icon.style.width = icon.naturalWidth / 2 + "px";
//     icon.style.height = icon.naturalHeight / 2 + "px";
//     if (window.outerWidth <= 991) {
//       icon.style.width = icon.naturalWidth / 4 + "px";
//       icon.style.height = icon.naturalHeight / 4 + "px";
//     }
//   });
// };

// window.addEventListener("DOMContentLoaded", () => {
//   adjustImgSize();
//   window.addEventListener("resize", () => {
//     adjustImgSize();
//   });
// });

// Simulator
window.addEventListener("DOMContentLoaded", () => {
  const jsSimulateBtn = document.getElementById("js-simulate-btn");
  if (jsSimulateBtn !== null) {
    jsSimulateBtn.addEventListener("click", () => {
      // 1. 売上高はいくらですか?
      let q1 = document.getElementById("q1").value;
      // 2. 従業員は何名ですか？?
      let q2 = document.getElementById("q2").value;
      // 3. 法人ですか？ 個人ですか？
      let q3 = document.getElementById("q3").value;
      // 4. 消費税課税事業者ですか？
      let q4 = document.getElementById("q4").value;

      let estimate;

      // 1千万円以下
      if (q1 === "q1_1") {
        if (q3 === "q3_1") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 15000;
            } else if (q2 === "q2_2") {
              estimate = 15000;
            } else if (q2 === "q2_3") {
              estimate = 20000;
            }
          }
          // 課税事業者
          else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 20000;
            } else if (q2 === "q2_2") {
              estimate = 20000;
            } else if (q2 === "q2_3") {
              estimate = 25000;
            }
          }
        } else if (q3 === "q3_2") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 10000;
            } else if (q2 === "q2_2") {
              estimate = 10000;
            } else if (q2 === "q2_3") {
              estimate = 15000;
            }
          } else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 15000;
            } else if (q2 === "q2_2") {
              estimate = 15000;
            } else if (q2 === "q2_3") {
              estimate = 20000;
            }
          }
        }
      }

      // 1千万円～5千万円以下
      if (q1 === "q1_2") {
        if (q3 === "q3_1") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 20000;
            } else if (q2 === "q2_2") {
              estimate = 25000;
            } else if (q2 === "q2_3") {
              estimate = 30000;
            }
          }
          // 課税事業者
          else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 25000;
            } else if (q2 === "q2_2") {
              estimate = 30000;
            } else if (q2 === "q2_3") {
              estimate = 35000;
            }
          }
        } else if (q3 === "q3_2") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 15000;
            } else if (q2 === "q2_2") {
              estimate = 20000;
            } else if (q2 === "q2_3") {
              estimate = 25000;
            }
          } else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 20000;
            } else if (q2 === "q2_2") {
              estimate = 25000;
            } else if (q2 === "q2_3") {
              estimate = 30000;
            }
          }
        }
      }

      // 5千万～1億円以下
      if (q1 === "q1_3") {
        if (q3 === "q3_1") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 25000;
            } else if (q2 === "q2_2") {
              estimate = 30000;
            } else if (q2 === "q2_3") {
              estimate = 35000;
            }
          }
          // 課税事業者
          else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 30000;
            } else if (q2 === "q2_2") {
              estimate = 35000;
            } else if (q2 === "q2_3") {
              estimate = 40000;
            }
          }
        } else if (q3 === "q3_2") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 20000;
            } else if (q2 === "q2_2") {
              estimate = 25000;
            } else if (q2 === "q2_3") {
              estimate = 30000;
            }
          } else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 25000;
            } else if (q2 === "q2_2") {
              estimate = 30000;
            } else if (q2 === "q2_3") {
              estimate = 35000;
            }
          }
        }
      }

      // 1億円～1億5千万円以下
      if (q1 === "q1_4") {
        if (q3 === "q3_1") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 30000;
            } else if (q2 === "q2_2") {
              estimate = 35000;
            } else if (q2 === "q2_3") {
              estimate = 40000;
            }
          }
          // 課税事業者
          else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 35000;
            } else if (q2 === "q2_2") {
              estimate = 40000;
            } else if (q2 === "q2_3") {
              estimate = 45000;
            }
          }
        } else if (q3 === "q3_2") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 25000;
            } else if (q2 === "q2_2") {
              estimate = 30000;
            } else if (q2 === "q2_3") {
              estimate = 35000;
            }
          } else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 30000;
            } else if (q2 === "q2_2") {
              estimate = 35000;
            } else if (q2 === "q2_3") {
              estimate = 40000;
            }
          }
        }
      }

      // 1億5千万円～2億円以下
      if (q1 === "q1_5") {
        if (q3 === "q3_1") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 35000;
            } else if (q2 === "q2_2") {
              estimate = 40000;
            } else if (q2 === "q2_3") {
              estimate = 45000;
            }
          }
          // 課税事業者
          else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 40000;
            } else if (q2 === "q2_2") {
              estimate = 45000;
            } else if (q2 === "q2_3") {
              estimate = 50000;
            }
          }
        } else if (q3 === "q3_2") {
          if (q4 === "q4_2") {
            if (q2 === "q2_1") {
              estimate = 30000;
            } else if (q2 === "q2_2") {
              estimate = 35000;
            } else if (q2 === "q2_3") {
              estimate = 40000;
            }
          } else if (q4 === "q4_1") {
            if (q2 === "q2_1") {
              estimate = 35000;
            } else if (q2 === "q2_2") {
              estimate = 40000;
            } else if (q2 === "q2_3") {
              estimate = 45000;
            }
          }
        }
      }

      // 2億円～
      if (q1 === "q1_6") {
        if (q2 === "q2_1") {
          estimate = 40000;
        } else if (q2 === "q2_2") {
          estimate = 45000;
        } else if (q2 === "q2_3") {
          estimate = 50000;
        }
      }

      if (q1 === "q1_6" || q2 === "q2_3") {
        jQuery("#js-reference-price").removeClass("d-none");
      } else {
        jQuery("#js-reference-price").addClass("d-none");
      }

      document.getElementById("js-total-amount").innerHTML = (
        estimate * 12
      ).toLocaleString();
      document.getElementById("js-total-amount-2").innerHTML = (
        estimate * 12
      ).toLocaleString();
      document.getElementById(
        "js-amount-per-month"
      ).innerHTML = estimate.toLocaleString();

      document.getElementById(
        "js-amount-per-month"
      ).innerHTML = estimate.toLocaleString();

      const result = document.getElementById("js-simulator-result");
      // result.classList.remove("d-none");
      jQuery("#js-simulator-result").fadeIn(800);
      let resultPosition =
        window.pageYOffset + result.getBoundingClientRect().top;
      let headerHeight = document.getElementById("masthead").offsetHeight;
      resultPosition = resultPosition - headerHeight - 16;
      jQuery("body,html").animate({ scrollTop: resultPosition }, 500, "swing");
    });
  }
});

// luminous
window.addEventListener("DOMContentLoaded", () => {
  const jsDxLightbox = document.querySelectorAll(".js-dx-lightbox");
  new LuminousGallery(jsDxLightbox);
});

// Scroll
window.addEventListener("DOMContentLoaded", () => {
  jQuery('a[href*="#"].js-page-link').click(function () {
    console.log("click");
    let headerHeight = document.getElementById("masthead").offsetHeight;
    let elmHash = jQuery(this).attr("href");
    let pos = jQuery(elmHash).offset().top - 16 - headerHeight;
    jQuery("body,html").animate({ scrollTop: pos }, 500, "swing");
    return false;
  });
});

jQuery(function () {
  let url = jQuery(location).attr("href");
  let headerHeight = document.getElementById("masthead").offsetHeight;
  if (url.indexOf("#") != -1) {
    jQuery("body,html").stop().scrollTop(0);

    let anchor = url.split("#");
    let target = jQuery("#" + anchor[anchor.length - 1]);
    if (target.length) {
      let pos = Math.floor(target.offset().top) - 16 - headerHeight;
      jQuery("html, body").animate({ scrollTop: pos }, 500, "swing");
    }
  }
});

// Fixed footer
//スクロールした際の動きを関数でまとめる
const fixedButton = () => {
  let scroll = jQuery(window).scrollTop();
  if (scroll >= 100) {
    jQuery("#fixed-button").removeClass("js-down-move");
    jQuery("#fixed-button").addClass("js-up-move");
  } else {
    if (jQuery("#fixed-button").hasClass("js-up-move")) {
      jQuery("#fixed-button").removeClass("js-up-move");
      jQuery("#fixed-button").addClass("js-down-move");
    }
  }
};

// 画面をスクロールをしたら動かしたい場合の記述
jQuery(window).scroll(function () {
  fixedButton(); /* スクロールした際の動きの関数を呼ぶ*/
});

// ページが読み込まれたらすぐに動かしたい場合の記述
jQuery(window).on("load", function () {
  fixedButton(); /* スクロールした際の動きの関数を呼ぶ*/
});
